/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import { spacing } from '$variables/theme';

export const StudentDetailsWrapper = styled.div`
  margin-bottom: ${spacing.xxLarge};
`;
